// web运行信息
class RunInfoHelper {
  static ua = navigator.userAgent

  // 是否是苹果设备
  static isAppleDevice() {
    return this.ua.indexOf('Mac OS X') > -1
  }

  // 是否是安卓设备
  static isAndroidDevice() {
    return this.ua.indexOf('Android') > -1 || this.ua.indexOf('Linux') > -1
  }

  // 打开页面的app
  static openIn() {
    let openIn = ''
    let ua = this.ua
    ua = ua.toLowerCase()

    if (/weibo/i.test(ua)) {
      // 在新浪微博客户端打开
      openIn = 'weibo'
    }
    if (/qq/i.test(ua)) {
      // 在QQ程序中打开
      openIn = 'qq'
    }
    if (/chrome/i.test(ua)) {
      openIn = 'chrome'
    }
    if (/microMessenger/i.test(ua)) {
      // 在微信中打开
      openIn = 'weixin'
    }
    return openIn
  }
}

export default RunInfoHelper
